import { render, staticRenderFns } from "./screenSetting.vue?vue&type=template&id=a93f8efa&scoped=true&"
import script from "./screenSetting.vue?vue&type=script&lang=js&"
export * from "./screenSetting.vue?vue&type=script&lang=js&"
import style0 from "./screenSetting.vue?vue&type=style&index=0&id=a93f8efa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93f8efa",
  null
  
)

export default component.exports